var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvAttachedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26803 6.26801 0 14 0H41.9942C49.7262 0 55.9942 6.26801 55.9942 14V41.9942C55.9942 49.7262 49.7262 55.9942 41.9942 55.9942H14C6.26803 55.9942 0 49.7262 0 41.9942V14Z",
    fill: "#FEF2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9914 39.659C20.3728 39.659 19.7796 39.4133 19.3421 38.9759C18.9047 38.5385 18.659 37.9452 18.659 37.3267V18.6676C18.659 18.0491 18.9047 17.4558 19.3421 17.0184C19.7796 16.581 20.3728 16.3353 20.9914 16.3353H30.3209C30.6901 16.3347 31.0557 16.4071 31.3967 16.5484C31.7378 16.6897 32.0475 16.8971 32.3081 17.1586L36.4924 21.3429C36.7546 21.6035 36.9625 21.9136 37.1043 22.255C37.246 22.5965 37.3186 22.9627 37.318 23.3324V37.3267C37.318 37.9452 37.0723 38.5385 36.6349 38.9759C36.1975 39.4133 35.6042 39.659 34.9856 39.659H20.9914Z",
    stroke: "#FB2C36",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3209 16.3353V22.1662C30.3209 22.4755 30.4438 22.7721 30.6625 22.9908C30.8812 23.2095 31.1778 23.3324 31.4871 23.3324H37.318",
    stroke: "#FB2C36",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6562 24.4985H23.3238",
    stroke: "#FB2C36",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6533 29.1633H23.3238",
    stroke: "#FB2C36",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6533 33.8281H23.3238",
    stroke: "#FB2C36",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvAttachedIcon);
export default __webpack_public_path__ + "static/media/inv_attached_icon.fff448c396f9091503a7fbe6283fb887.svg";
export { ForwardRef as ReactComponent };